import { useTranslation } from 'react-i18next';
import { useGetPageTitle } from 'services/helpers/seo';
import HeadMetaData from '../HeadMetaData';

const PageMeta = () => {
  const { t } = useTranslation();
  const { pageTitle, pageDescription } = useGetPageTitle();
  return (
    <HeadMetaData
      title={pageTitle || t('meta:generalTitle')}
      contentDescription={
        pageDescription || t('meta:generalContentDescription')
      }
    />
  );
};

export default PageMeta;
